import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    phone: Yup.string()
        .required('El teléfono es requerido')
        .max(15, 'Ingresar texto válido'),
})

export default {
    validationSchema
}